import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {NGXLogger} from 'ngx-logger';
import {InhaberEntitiesActions, mappedHttpErrorResponseOperator} from '@adnova/jf-ng-components';
import {catchError, filter, map, switchMap} from 'rxjs/operators';
import {UmsatzsteuerService} from '../../openapi/fakturierung-openapi';
import {UmsatzsteuerschluesselEntitiesActions} from '../actions/umsatzsteuerschluessel-entities.actions';
import {exhaustMap, of, take} from 'rxjs';
import {UmsatzsteuerschluesselExtended} from '../../interfaces/umsatzsteuerschluessel-extended.interface';
import {Store} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {UmsatzsteuerschluesselEntitiesSelectors} from '../selectors/umsatzsteuerschluessel-entities.selectors';


@Injectable()
export class UmsatzsteuerschluesselEntitiesEffects {
  private _actions$ = inject(Actions);
  private _logger = inject(NGXLogger);
  private _umsatzsteuerService = inject(UmsatzsteuerService);
  private _store = inject(Store<AppState>);

  readonly setCurrentInhaberIdFromURL$ = createEffect(
    () => this._actions$.pipe(
      ofType(InhaberEntitiesActions.setCurrentInhaberIdFromURL),
      map(action => action.currentInhaberId),
      filter((currentInhaberId): currentInhaberId is string => !!currentInhaberId),
      map(currentInhaberId => UmsatzsteuerschluesselEntitiesActions.readUmsatzsteuerschluessel({betriebId: currentInhaberId})),
    ),
  );

  readonly readUmsatzsteuerschluessel$ = createEffect(() =>
    this._actions$.pipe(
      ofType(UmsatzsteuerschluesselEntitiesActions.readUmsatzsteuerschluessel),
      exhaustMap(action =>
        this._store.select(UmsatzsteuerschluesselEntitiesSelectors.umsatzsteuerschluesselByBetrieb(action.betriebId)).pipe(
          take(1),
          map(existingEntities => ({existingEntities, betriebId: action.betriebId}))
        )
      ),
      filter(({existingEntities}) => existingEntities.length === 0),
      switchMap(({betriebId}) =>
        this._umsatzsteuerService.readUmsatzsteuerschluessel(betriebId).pipe(
          map(umsatzsteuerschluesselDtos => {
            this._logger.debug('read umsatzsteuerschluessel succeeded.');
            return UmsatzsteuerschluesselEntitiesActions.readUmsatzsteuerschluesselSuccess({
              betriebId,
              umsatzsteuerschluesselDtos: umsatzsteuerschluesselDtos as UmsatzsteuerschluesselExtended[],
            });
          }),
          catchError(error =>
            of(error).pipe(
              mappedHttpErrorResponseOperator(error),
              switchMap(error => {
                this._logger.error('read umsatzsteuerschluessel failed.', 'error:', error);
                return [UmsatzsteuerschluesselEntitiesActions.readUmsatzsteuerschluesselFailed({error})];
              })
            )
          )
        )
      )
    )
  );

}
